// extracted by mini-css-extract-plugin
export default {"root":"ItXDSw","slides":"oUbPuF","navButton":"NxXEOK","showOnHover":"KZw9va","hidden":"YALISk","absolute":"iQoizP","arrowLeft":"Wq2I72","arrowRight":"ssYN4J"};